if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slideShowButtons = this.querySelectorAll('modal-thumbnails button');
        this.slideShowButtons.forEach(button => {
          button.addEventListener('click', this.getActiveMedia.bind(this));
        });

      }
  
      hide() {
        super.hide();
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getActiveMedia(event) {
        this.openedBy = event.target.querySelector('img');
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
          
        const activeMedia = this.querySelector(`[data-images] [data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeThumbnail = this.querySelector(`[data-thumbnails] [data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`).closest('button');
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeThumbnail.classList.add('active');
        activeMedia.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }